import React, { useState } from 'react';
import { authService, userService, appointmentService, chatService, communityService } from '../services';

const APITest = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const addResult = (test, status, message) => {
    setTestResults(prev => [...prev, { test, status, message, timestamp: new Date().toLocaleTimeString() }]);
  };

  const testAPIConnection = async () => {
    setLoading(true);
    setTestResults([]);

    try {
      // Test 1: Kiểm tra kết nối cơ bản
      addResult('API Connection', 'testing', 'Đang kiểm tra kết nối...');
      
      // Test 2: Test authentication endpoints
      try {
        await authService.register({
          email: 'test@example.com',
          password: 'test123',
          name: 'Test User'
        });
        addResult('Auth Register', 'success', 'Đăng ký thành công');
      } catch (error) {
        if (error.response?.status === 400) {
          addResult('Auth Register', 'warning', 'User đã tồn tại hoặc dữ liệu không hợp lệ');
        } else {
          addResult('Auth Register', 'error', `Lỗi: ${error.message}`);
        }
      }

      // Test 3: Test login
      try {
        const loginResult = await authService.login('test@example.com', 'test123');
        addResult('Auth Login', 'success', 'Đăng nhập thành công');
      } catch (error) {
        addResult('Auth Login', 'error', `Lỗi đăng nhập: ${error.message}`);
      }

      // Test 4: Test user service
      try {
        const user = authService.getCurrentUser();
        if (user) {
          addResult('User Service', 'success', 'Lấy thông tin user thành công');
        } else {
          addResult('User Service', 'warning', 'Chưa có user đăng nhập');
        }
      } catch (error) {
        addResult('User Service', 'error', `Lỗi user: ${error.message}`);
      }

      // Test 5: Test appointment service
      try {
        await appointmentService.getAppointments(1, 1, 10);
        addResult('Appointment Service', 'success', 'Lấy danh sách appointments thành công');
      } catch (error) {
        addResult('Appointment Service', 'error', `Lỗi appointments: ${error.message}`);
      }

      // Test 6: Test chat service
      try {
        await chatService.getConversations(1);
        addResult('Chat Service', 'success', 'Lấy danh sách conversations thành công');
      } catch (error) {
        addResult('Chat Service', 'error', `Lỗi chat: ${error.message}`);
      }

      // Test 7: Test community service
      try {
        await communityService.getPosts(1, 10);
        addResult('Community Service', 'success', 'Lấy danh sách posts thành công');
      } catch (error) {
        addResult('Community Service', 'error', `Lỗi community: ${error.message}`);
      }

    } catch (error) {
      addResult('API Connection', 'error', `Lỗi kết nối: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const clearResults = () => {
    setTestResults([]);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>API Connection Test</h2>
      <p>Kiểm tra kết nối với backend C# tại: https://localhost:7214</p>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testAPIConnection} 
          disabled={loading}
          style={{
            padding: '10px 20px',
            backgroundColor: loading ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Đang test...' : 'Test API Connection'}
        </button>
        
        <button 
          onClick={clearResults}
          style={{
            padding: '10px 20px',
            marginLeft: '10px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Clear Results
        </button>
      </div>

      <div>
        <h3>Test Results:</h3>
        {testResults.length === 0 ? (
          <p>Chưa có kết quả test nào. Nhấn "Test API Connection" để bắt đầu.</p>
        ) : (
          <div>
            {testResults.map((result, index) => (
              <div 
                key={index}
                style={{
                  padding: '10px',
                  margin: '5px 0',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: 
                    result.status === 'success' ? '#d4edda' :
                    result.status === 'error' ? '#f8d7da' :
                    result.status === 'warning' ? '#fff3cd' : '#e2e3e5'
                }}
              >
                <strong>{result.test}</strong> - {result.status.toUpperCase()}
                <br />
                <small>{result.timestamp}</small>
                <br />
                {result.message}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default APITest;
